import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const test = r => require.ensure([], () => r(require('@/pages/test')), 'test');
const login = r => require.ensure([], () => r(require('@/pages/login')), 'login');
const index = r => require.ensure([], () => r(require('@/pages/index')), 'index');
const home = r => require.ensure([], () => r(require('@/pages/home')), 'home');
/***************************系统管理********************************** */
const userManage = r => require.ensure([], () => r(require('@/pages/backstageManagement/userManage')), 'userManage');//	用户管理
const menuManage = r => require.ensure([], () => r(require('@/pages/backstageManagement/menuManage')), 'menuManage');//	菜单管理
const roleManage = r => require.ensure([], () => r(require('@/pages/backstageManagement/roleManage')), 'roleManage');//	角色管理
const pictureManage = r => require.ensure([], () => r(require('@/pages/backstageManagement/pictureManage')), 'pictureManage');//	图片设置
/***************************平台管理********************************** */
const carrierManagement = r => require.ensure([], () => r(require('@/pages/platformManagement/carrierManagement')), 'carrierManagement');//	运营商管理
const projectManagement = r => require.ensure([], () => r(require('@/pages/platformManagement/projectManagement')), 'projectManagement');//	项目管理
/***************************基本管理********************************** */
const buildingManagement = r => require.ensure([], () => r(require('@/pages/basicManagement/buildingManagement')), 'buildingManagement');//	楼栋管理
const houseManagement = r => require.ensure([], () => r(require('@/pages/basicManagement/houseManagement')), 'houseManagement');//	房屋管理
/***************************住户信息管理********************************** */
const householdManagement = r => require.ensure([], () => r(require('@/pages/householdManagement/householdManagement')), 'householdManagement');//	住户管理
const householdAudit = r => require.ensure([], () => r(require('@/pages/householdManagement/householdAudit')), 'householdAudit');//	住户审核
/***************************物业人员管理********************************** */
const propertyManage = r => require.ensure([], () => r(require('@/pages/backstageManagement/propertyManage')), 'propertyManage');//	物业人员管理
/***************************社区安防********************************** */
const deviceManagement = r => require.ensure([], () => r(require('@/pages/communitySecurity/deviceManagement')), 'deviceManagement');//	设备管理
const doorOpeningRecord = r => require.ensure([], () => r(require('@/pages/communitySecurity/doorOpeningRecord')), 'doorOpeningRecord');//	开门记录
const routes = [
  	{
		path: '/login',
    	component: login,
		name: '',
		meta: ['登录']
	},{
		path: '/test',
    	component: test,
		name: '',
		meta: ['测试']
	},{
		path: '/',
    	component: index,
		name: '',
		meta: ['我的地盘', '首页'],
		children: [{
/************************首页******************************* */
			path: '',
			component: home,
			meta: ['首页']
		},{
/************************系统管理******************************* */
			path: '/userManage',
			component: userManage,
      		meta: ['系统管理', '用户管理']
		},{
			path: '/menuManage',
			component: menuManage,
      		meta: ['系统管理', '菜单管理']
		},{
			path: '/roleManage',
			component: roleManage,
      		meta: ['系统管理', '角色管理']
		},{
			path: '/pictureManage',
			component: pictureManage,
      		meta: ['系统管理', '图片设置']
		},{
/************************平台管理******************************* */
			path: '/carrierManagement',
			component: carrierManagement,
      		meta: ['平台管理', '运营商管理']
		},{
			path: '/projectManagement',
			component: projectManagement,
      		meta: ['平台管理', '项目管理']
		},{
/************************基本管理******************************* */
			path: '/buildingManagement',
			component: buildingManagement,
      		meta: ['基本管理', '楼栋管理']
		},{
			path: '/houseManagement',
			component: houseManagement,
      		meta: ['基本管理', '房屋管理']
		},{
/************************住户管理******************************* */
			path: '/householdManagement',
			component: householdManagement,
      		meta: ['住户管理', '住户管理']
		},{
			path: '/householdAudit',
			component: householdAudit,
      		meta: ['住户管理', '住户审核']
		},{
/************************物业人员管理******************************* */
			path: '/propertyManage',
			component: propertyManage,
      		meta: ['物业人员管理']
		},{
/************************社区安防******************************* */
			path: '/deviceManagement',
			component: deviceManagement,
      		meta: ['社区安防', '设备管理']
		},{
			path: '/doorOpeningRecord',
			component: doorOpeningRecord,
      		meta: ['社区安防', '开门记录']
		}],
	},
]

export default new Router({
	mode: 'history',
	base: '/ymjp/',
	routes,
})



// WEBPACK FOOTER //
// ./src/router/index.js